import { useEffect, useState } from 'react'

import {
  GoogleMap,
  InfoWindow,
  LoadScript,
  Marker,
} from '@react-google-maps/api'
import Text from 'shared/components/Text'

import { IMapaLoteProps } from './MapaLote.types'

const containerStyle = {
  width: '100%',
  height: '100%',
}

const MapaImpl: React.FC<IMapaLoteProps> = ({ origem, destino }) => {
  const [markerMap, setMarkerMap] = useState({})
  const [selectedPlace, setSelectedPlace] = useState(null)
  const [infoOpen, setInfoOpen] = useState(false)

  useEffect(() => {
    setInfoOpen(false)
    setSelectedPlace({
      uid: origem.uid,
      lat: origem.coordenadas.latitude,
      lng: origem.coordenadas.longitude,
      nome: origem.nome,
    })
    setInfoOpen(true)
  }, [origem, destino])

  const origemPosition = {
    lat: origem.coordenadas.latitude,
    lng: origem.coordenadas.longitude,
  }
  const destinoPosition = {
    lat: destino.coordenadas.latitude,
    lng: destino.coordenadas.longitude,
  }
  const markerLoadHandler = (marker, place) => {
    return setMarkerMap(prevState => {
      return { ...prevState, [place.uid]: marker }
    })
  }

  const markerClickHandler = (event, place) => {
    setSelectedPlace(place)
    if (infoOpen) {
      setInfoOpen(false)
    }
    setInfoOpen(true)
  }

  return (
    <LoadScript
      id="google-map-script"
      googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}
    >
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={origemPosition}
        zoom={5.2}
      >
        <Marker
          position={origemPosition}
          onLoad={marker =>
            markerLoadHandler(marker, {
              uid: origem.uid,
              lat: origemPosition.lat,
              lng: origemPosition.lng,
              nome: origem.nome,
            })
          }
          onClick={event =>
            markerClickHandler(event, {
              uid: origem.uid,
              lat: origemPosition.lat,
              lng: origemPosition.lng,
              nome: origem.nome,
            })
          }
        />
        <Marker
          position={destinoPosition}
          onLoad={marker =>
            markerLoadHandler(marker, {
              uid: destino.uid,
              lat: destinoPosition.lat,
              lng: destinoPosition.lng,
              nome: destino.nome,
            })
          }
          onClick={event =>
            markerClickHandler(event, {
              uid: destino.uid,
              lat: destinoPosition.lat,
              lng: destinoPosition.lng,
              nome: destino.nome,
            })
          }
        />
        {infoOpen && selectedPlace && (
          <InfoWindow
            anchor={markerMap[selectedPlace.uid]}
            onCloseClick={() => setInfoOpen(false)}
          >
            <>
              {selectedPlace.nome.split('-').map((texto, idx) => {
                return (
                  <Text key={idx} size={12} fontStyle="italic">
                    {texto}
                  </Text>
                )
              })}
            </>
          </InfoWindow>
        )}
      </GoogleMap>
    </LoadScript>
  )
}

export default MapaImpl
